import { render, staticRenderFns } from "./loanproductdescription.vue?vue&type=template&id=73ab514a&scoped=true&"
import script from "./loanproductdescription.vue?vue&type=script&lang=js&"
export * from "./loanproductdescription.vue?vue&type=script&lang=js&"
import style0 from "./loanproductdescription.vue?vue&type=style&index=0&id=73ab514a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ab514a",
  null
  
)

export default component.exports